"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fioDescribePath = exports.FioEncryptionContentType = exports.Fio = void 0;
const utils_1 = require("./utils");
var Fio;
(function (Fio) {
    let ContentType;
    (function (ContentType) {
        ContentType["REQUEST"] = "new_funds_content";
        ContentType["OBT"] = "record_obt_data_content";
    })(ContentType = Fio.ContentType || (Fio.ContentType = {}));
})(Fio = exports.Fio || (exports.Fio = {}));
exports.FioEncryptionContentType = Fio.ContentType;
function fioDescribePath(path) {
    let pathStr = utils_1.addressNListToBIP32(path);
    let unknown = {
        verbose: pathStr,
        coin: "Fio",
        isKnown: false,
    };
    if (path.length != 5) {
        return unknown;
    }
    if (path[0] != 0x80000000 + 44) {
        return unknown;
    }
    if (path[1] != 0x80000000 + utils_1.slip44ByCoin("Fio")) {
        return unknown;
    }
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) {
        return unknown;
    }
    if (path[3] !== 0 || path[4] !== 0) {
        return unknown;
    }
    let index = path[2] & 0x7fffffff;
    return {
        verbose: `Fio Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Fio",
        isKnown: true,
        isPrefork: false,
    };
}
exports.fioDescribePath = fioDescribePath;
